import { useState } from 'react';
import { Alert, Button, Checkbox, Modal, Typography, message } from 'antd';
import { useExportBudgetData } from 'app/hooks/useExportBudgetData';
import { BudgetType } from 'app/types/budget/budget.types';
import 'app/components/modules/budget/export_budget_modal/export_budget_modal.scss';

const ExportBudgetModal = ({
    budget,
    isVisible,
    closeModalHandler,
}: {
    budget: BudgetType | undefined;
    isVisible: boolean;
    closeModalHandler: () => void;
}) => {
    const exportData = useExportBudgetData();
    const [includeHeadings, setIncludeHeadings] = useState(true);
    const [includeRegistered, setIncludeRegistered] = useState(true);
    const [includeVariance, setIncludeVariance] = useState(false);

    const handleExport = () => {
        try {
            exportData({ data: budget!, includeHeadings, includeRegistered, includeVariance });
            closeModalHandler();
        } catch {
            message.error('Unable to export your budget. Please try again.');
        }
    };

    return (
        <Modal
            open={isVisible}
            title='Export budget'
            onCancel={closeModalHandler}
            width={520}
            className='export-budget-modal'
            destroyOnClose
            footer={null}
            centered
        >
            <Typography.Paragraph>
                Download an Excel workbook (.xlsx) with your financial summary, budget detail, and
                event assumptions, including entry fees and participant projections.
            </Typography.Paragraph>
            <Alert
                type='info'
                showIcon
                message='A snapshot of your budget'
                description='Values reflect your budget at the time of export. Editing the workbook does not recalculate the budget or update RDHQ.'
            />
            <div className='export-budget-modal__additional'>
                <Checkbox
                    checked={includeHeadings}
                    onChange={(e) => setIncludeHeadings(e.target.checked)}
                >
                    Include item group column
                </Checkbox>
                <Checkbox
                    checked={includeRegistered}
                    onChange={(e) => setIncludeRegistered(e.target.checked)}
                >
                    Include registered participant figures
                </Checkbox>
                <Checkbox
                    checked={includeVariance}
                    onChange={(e) => setIncludeVariance(e.target.checked)}
                >
                    Include variance sheet
                </Checkbox>
            </div>
            <Button
                type='primary'
                className='export-budget-modal__cta'
                disabled={!budget}
                onClick={handleExport}
            >
                Export Excel
            </Button>
        </Modal>
    );
};

export default ExportBudgetModal;
